import React from 'react'
import propTypes from 'prop-types'
import {connect} from 'react-redux'
import {unTrackRoutes} from 'actions/routing'

const ErrorReload = (props) => {
  props.onUnTrackRoutes()
  window.location.reload()
  return <div/>
}

ErrorReload.propTypes = {
  onUnTrackRoutes: propTypes.func.isRequired,
}

const mapDispatchToProps = (dispatch) => {
  return {
    onUnTrackRoutes: () => dispatch(unTrackRoutes()),
  }
}

export default connect(null, mapDispatchToProps)(ErrorReload)
